import { useMediaQuery as useMediaQueryResponsive } from 'react-responsive';

export const useMediaQuery = (width = 768) => {
  const isDesktopOrLaptop = useMediaQueryResponsive({ minWidth: width });

  return isDesktopOrLaptop;
};
